import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProducts } from "../lib/api";
import { useCart } from "../context/CartContext";
import { Reveal } from "../components/Reveal";
import { toast } from "sonner";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("All");
  const { addItem } = useCart();
  const navigate = useNavigate();

  useEffect(() => { getProducts().then(setProducts).catch(() => {}); }, []);

  const categories = ["All", ...Array.from(new Set(products.map((p) => p.category)))];
  const shown = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <main className="pt-32 pb-28 min-h-screen relative z-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="overline text-[#B0872A] mb-4">Clinical Skincare</p>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tight mb-10">The Collection</h1>

        <div className="flex flex-wrap gap-3 mb-14">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setFilter(c)}
              className={`px-5 py-2 rounded-full text-sm border transition-colors ${
                filter === c ? "bg-[#1A1A1A] text-white border-[#1A1A1A]" : "border-[#DAD5E2] text-[#57515F] hover:border-[#1A1A1A]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {shown.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <div data-testid={`product-card-${p.id}`} className="group">
                <div className="hover-scale-img bg-white rounded-xl h-96 mb-5 cursor-pointer" onClick={() => navigate(`/product/${p.id}`)}>
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover rounded-xl" />
                </div>
                <div className="flex justify-between items-start">
                  <div className="cursor-pointer" onClick={() => navigate(`/product/${p.id}`)}>
                    <p className="overline text-[#B0872A] mb-1">{p.category}</p>
                    <h3 className="font-display text-2xl tracking-tight">{p.name}</h3>
                    <p className="text-[#57515F] text-sm">{p.tagline}</p>
                    <p className="mt-1 font-medium">${p.price.toFixed(2)}</p>
                  </div>
                  <button
                    data-testid={`add-to-cart-${p.id}`}
                    onClick={() => { addItem(p); toast.success(`${p.name} added to cart`); }}
                    className="btn-secondary py-2 px-5 text-sm"
                  >
                    Add
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
